/**
 * RESPONSIBILITY: the /adc page's slim header and its opening card.
 *
 * No @EditableBy, so WRITE defaults to NONE - admin only.
 */
import type { ImageValue } from '@framework/core';
import { Section, Text, Paragraph, Link, Img, Bool } from '@framework/core/decorators';
import { SectionName } from '../section-names';

@Section({ name: SectionName.AdcTop, label: 'Austin Desi Christmas - Header and opening card' })
export class AdcTopSection {
  @Bool({
    label: 'Show the header', default: false, group: 'Header',
    description: 'Tick to show the header: the logo, the name and the string of coloured lights beneath it. Hidden until ticked.',
  })
  showHeader!: boolean;

  @Img({ label: 'Logo', folder: 'adc', maxSizeMb: 4, size: '400 × 120', group: 'Header' })
  logo!: ImageValue;

  @Text({ label: 'Name beside the logo', maxLength: 120, default: 'Austin Christian Fellowship of India', group: 'Header' })
  brand!: string;

  @Link({ label: 'Where the logo goes', default: 'https://acfi.cc', group: 'Header', description: 'Leave empty for no link.' })
  brandHref!: string;

  @Text({ label: 'Button text', maxLength: 60, default: 'Register', group: 'Header' })
  registerLabel!: string;

  @Link({ label: 'Button link', group: 'Header', description: 'Where the button goes, e.g. a form. Empty hides the button.' })
  registerHref!: string;

  @Img({
    label: 'Title picture', folder: 'adc', maxSizeMb: 4, size: '1200 × 400', group: 'Opening card',
    description: 'A logo or lettering that says the title. When there is one, it is shown INSTEAD of the title words below, never beside them.',
  })
  titleImage!: ImageValue;

  @Text({ label: 'Title', maxLength: 300, default: 'Austin Desi Christmas', group: 'Opening card', description: 'Shown only when there is no title picture.' })
  heading!: string;

  @Text({ label: 'Subtitle', maxLength: 300, default: 'Christmas with an Indian flavor', group: 'Opening card' })
  tagline!: string;

  @Text({ label: 'Label over the date', maxLength: 40, default: 'When', group: 'Opening card' })
  whenLabel!: string;

  @Text({ label: 'Date and time', maxLength: 300, default: 'Date and time to be announced', group: 'Opening card' })
  when!: string;

  @Text({ label: 'Label over the place', maxLength: 40, default: 'Where', group: 'Opening card' })
  whereLabel!: string;

  @Paragraph({ label: 'Place', maxLength: 600, rows: 2, default: 'Venue to be announced', group: 'Opening card' })
  where!: string;

  @Img({ label: 'Background photo', folder: 'adc', maxSizeMb: 12, size: '1920 × 1080', group: 'Opening card', description: 'Fills the opening band behind the title, softened so the words stay readable.' })
  image!: ImageValue;
}
